import { CommandCentrePosition, LinkHealth, OperatorPresence } from '@/types';
import { PRESENCE_COLORS } from '@/ui/components/Map/constants';

export { PRESENCE_COLORS };

export type TrackingThresholds = {
  offlineSeconds: number;
  linkHealthGoodSeconds: number;
  decayTickMs: number;
  awayTimeoutMinutes: number;
};

/** Fallback when GET /CommandCentre/config is unavailable. */
export const DEFAULT_TRACKING_THRESHOLDS: TrackingThresholds = {
  offlineSeconds: 180,
  linkHealthGoodSeconds: 70,
  decayTickMs: 10_000,
  awayTimeoutMinutes: 30,
};

/** @deprecated Prefer DEFAULT_TRACKING_THRESHOLDS or useCommandCentreTrackingThresholds. */
export const TRACKING_THRESHOLDS = DEFAULT_TRACKING_THRESHOLDS;

export function applyTrackingDecay(
  positions: CommandCentrePosition[],
  elapsedSeconds: number,
  thresholds: TrackingThresholds = DEFAULT_TRACKING_THRESHOLDS,
): CommandCentrePosition[] {
  if (elapsedSeconds <= 0) return positions;

  const awayAfterSeconds = thresholds.awayTimeoutMinutes * 60;

  return positions.map((position) => {
    const ageSeconds = position.ageSeconds + elapsedSeconds;
    const secondsSinceLastMoved =
      (position.secondsSinceLastMoved ?? 0) + elapsedSeconds;
    let presence = position.presence;
    let linkHealth: LinkHealth | null | undefined = position.linkHealth;

    if (ageSeconds > thresholds.offlineSeconds) {
      presence = 'Offline';
      linkHealth = null;
    } else if (secondsSinceLastMoved >= awayAfterSeconds) {
      presence = 'Away';
      if (
        ageSeconds > thresholds.linkHealthGoodSeconds &&
        linkHealth === 'Good'
      ) {
        linkHealth = 'Degrading';
      }
    } else if (
      ageSeconds > thresholds.linkHealthGoodSeconds &&
      linkHealth === 'Good'
    ) {
      linkHealth = 'Degrading';
    }

    return {
      ...position,
      ageSeconds,
      secondsSinceLastMoved,
      presence,
      linkHealth,
    };
  });
}

export function presenceLabel(presence: OperatorPresence): string {
  switch (presence) {
    case 'Online':
      return 'Online';
    case 'Away':
      return 'Away';
    default:
      return 'Offline';
  }
}

export function presenceCssClass(presence: OperatorPresence): string {
  return presence.toLowerCase();
}
